import { useEffect, useState } from "react";

const links = [
  { href: "#features", label: "核心功能" },
  { href: "#works", label: "在追作品" },
  { href: "#calendar", label: "追更日历" },
  { href: "#steps", label: "使用流程" },
  { href: "#reviews", label: "用户口碑" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex w-full items-center justify-between px-4 py-3 md:px-6 lg:px-10">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap" aria-label="汗汗虫虫漫画 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl text-foreground-950">汗汗虫虫漫画</span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="主导航">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#contact"
            className="whitespace-nowrap rounded-md border border-primary-200 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
          >
            登录
          </a>
          <a
            href="#works"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追更
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-900 lg:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/95 px-4 py-4 backdrop-blur lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md border border-primary-200 px-3 py-2.5 text-center text-sm font-medium text-primary-700"
            >
              登录
            </a>
            <a
              href="#works"
              onClick={() => setOpen(false)}
              className="whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              开始追更
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}